import { Settings2, Copy, Trash2 } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import type { ViewListItem } from '@/types/api'

interface ViewSettingsDropdownProps {
  view: ViewListItem | null
  currentUserId: string
  onDuplicate: () => void
  onDelete: () => void
}

export function ViewSettingsDropdown({
  view,
  currentUserId,
  onDuplicate,
  onDelete,
}: ViewSettingsDropdownProps) {
  if (!view) return null

  const isGlobal = view.type === 'GLOBAL'
  const isOwner = view.createdByUserId === currentUserId
  const canDelete = isOwner && !isGlobal

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="gap-2 border-primary/20 bg-white/10 px-3 py-2 text-sm text-primary shadow-none hover:bg-primary/5 [&>svg]:text-primary"
        >
          <Settings2 className="h-4 w-4" />
          <span className="hidden sm:inline">View Settings</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem onClick={onDuplicate}>
          <Copy className="size-4" />
          Duplicate
        </DropdownMenuItem>
        {canDelete && (
          <DropdownMenuItem
            onClick={onDelete}
            className="text-destructive hover:text-destructive focus:text-destructive"
          >
            <Trash2 className="size-4" />
            Delete
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
